import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";
const client = new ApiClient(client_core)

const endpoints = {
    impersonate: '/impersonate/user/impersonate/',
}

export default {
    async impersonate(id) {
        return await client.post(endpoints.impersonate, {user: id})
    }
}
